import angular from 'angular';
import template from './mic-notification.html';
class Controller {
    constructor($rootScope, $translate) {
        this.isActive = false;
        $rootScope.$on('onTurnOffAudioByPerson', (_event, person) => {
            this.isActive = true;
            this.text = $translate.instant('account.sidebar.video-controls.notification.turnOffAudioByPerson{username}', { username: person.state.username });
        });
    }
    hide($event) {
        $event.stopImmediatePropagation();
        this.text = '';
        this.isActive = false;
    }
}
const component = {
    template,
    bindings: {
        isActive: '=',
    },
    controller: Controller,
};
export default angular
    .module('doxy.videoChat.callActions.callActionsMicNotification', [])
    .component('callActionsMicNotification', component).name;
